// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XfrQ","question":"styles_question__TVLsD","inputVisibleButton":"styles_inputVisibleButton__15Lyp","note":"styles_note__zib2V"};